export enum ActivityItemType {
  Purchase = 'sl_purchase', // type_name: sl_purchase
  Referral = 'sl_referral', // type_name: sl_referral
  AdjustEarn = 'sl_adjust_earn', // type_name sl_adjust_earn
  Offer = 'sl_offer', // type_name: sl_offer
  Reward = 'sl_reward' // type_name: sl_referral
}

export interface ActivityItemI {
  label: string, //label | details.sl_label
  itemTypeName: string, //type_label
  itemTypeCode: string, //type_name
  location: string, // details.sl_location
  activityDate: string, // activity_ts
  metricAmount: number, // metric_amount
  submitter: string, // details.sl_submitter
  client: string, //details.sl_client
  activityMonthYearGroup: string,
  totalDollar: number, //sum of details.sl_balance.total_dollar array
  orderId: string
}